module.exports = __webpack_public_path__ + "media/images/phone/header-bookshelf-483902ab051cc549ab02faff85a60198.png";